import { getToken, removeToken, setToken } from 'src/app/services/localStorage';
import { checkingCredentials, loadTokenToStore, login, logout } from './authSlice';

const requestState = {
  success: 'SUCCESS',
  errorAuth: 'WRONG_CREDENTIALS',
  errorRequest: 'ERROR',
  waiting: 'WAITING',
};

export const checkAuthentication = () => async (dispatch) => {
  dispatch(checkingCredentials());

  const token = getToken();

  if (typeof token === 'string' && token.trim().length > 0) {
    dispatch(loadTokenToStore({ token, isAuthenticated: true }));
    return true;
  }

  dispatch(logout());
  return false;
};

export const forceAuthentication = () => {
  return async (dispatch) => {
    const fakeToken = 'ssn28290dn289swj8921892j892828';
    setToken(fakeToken);
    dispatch(loadTokenToStore({ token: fakeToken, isAuthenticated: true }));
  };
};

export const setAuthentication = (token) => {
  return async (dispatch) => {
    setToken(token);
    dispatch(login({ token, isAuthenticated: true }));
  };
};

export const removeAuthentication = (token) => {
  return async (dispatch) => {
    removeToken();
    dispatch(logout());
  };
};
